import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';

export default function MobileNavigation({
  currentView,
  setCurrentView,
  currentDate,
  handleNavigate,
  onAddNew,
  onCreateSeries,
  showPeople,
  setShowPeople,
  showProjects,
  setShowProjects,
  defaultUseNotes,
  setDefaultUseNotes,
  canUseBD,
  onOpenAdminPanel,
  showGamification,
  setShowGamification,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);
  const settingsDropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (mobileDropdownRef.current && !mobileDropdownRef.current.contains(event.target)) {
        setShowMobileDropdown(false);
      }
      if (settingsDropdownRef.current && !settingsDropdownRef.current.contains(event.target)) {
        setShowSettingsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      {/* Mobile Header - Fixed at top */}
      <div className="md:hidden fixed top-0 left-0 right-0 flex items-center justify-between p-3 border-b border-[#273C61] bg-[#0D1A27] z-[2000] text-white">
        {/* Left: Hamburger Menu */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="p-2 rounded-lg hover:bg-[#273C61] transition-colors min-h-touch-target min-w-[60px] flex items-center justify-center text-white"
          aria-label="Menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Center: Previous + Date + Next */}
        <div className="flex items-center gap-2 flex-1 justify-center">
          <button
            onClick={() => {
              const unit = currentView === 'day' || currentView === 'three_day' ? 'day' : currentView === 'month' ? 'month' : 'week';
              const amount = 1;
              const newDate = moment(currentDate).subtract(amount, unit).toDate();
              handleNavigate(newDate);
            }}
            className="p-2 rounded-full hover:bg-[#273C61] transition-colors min-h-touch-target min-w-touch-target flex items-center justify-center text-white"
            aria-label="Previous"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <div className="flex flex-col items-center mx-2">
            {(currentView === 'week' || currentView === 'work_week') && (
              <span className="text-xs font-medium px-2 py-0.5 bg-[#FF7800] text-white rounded-full mb-1">
                W{moment(currentDate).format('w')}
              </span>
            )}
            {currentView === 'three_day' && (
              <span className="text-xs font-medium px-2 py-0.5 bg-[#FF7800] text-white rounded-full mb-1">
                3D
              </span>
            )}
            <h2 className="text-base font-semibold text-center text-white">
              {currentView === 'day' 
                ? moment(currentDate).format('MMM D')
                : currentView === 'three_day'
                ? (() => {
                    const start = moment(currentDate);
                    const end = moment(currentDate).add(2, 'days');
                    return start.month() === end.month() 
                      ? `${start.format('MMM D')}-${end.format('D')}`
                      : `${start.format('MMM D')} - ${end.format('MMM D')}`;
                  })()
                : moment(currentDate).format('MMM YYYY')}
            </h2>
          </div>

          <button
            onClick={() => {
              const unit = currentView === 'day' || currentView === 'three_day' ? 'day' : currentView === 'month' ? 'month' : 'week';
              const amount = 1;
              const newDate = moment(currentDate).add(amount, unit).toDate();
              handleNavigate(newDate);
            }}
            className="p-2 rounded-full hover:bg-[#273C61] transition-colors min-h-touch-target min-w-touch-target flex items-center justify-center text-white"
            aria-label="Next"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Right: Add New Dropdown */}
        <div className="relative" ref={mobileDropdownRef}>
          <button
            onClick={() => setShowMobileDropdown(!showMobileDropdown)}
            className="px-5 py-2 text-xs font-bold bg-[#FF7800] text-white rounded-lg min-h-touch-target min-w-[60px] flex items-center gap-1"
          >
            Add
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          {/* Mobile Dropdown Menu */}
          {showMobileDropdown && (
            <div className="absolute right-0 mt-2 w-44 bg-[#0D1A27] border border-[#273C61] rounded-lg z-50">
              <div className="py-1">
                <button
                  onClick={() => {
                    onAddNew();
                    setShowMobileDropdown(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#273C61]"
                >
                  New entry
                </button>
                <button
                  onClick={() => {
                    onCreateSeries();
                    setShowMobileDropdown(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#273C61]"
                >
                  New series
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="md:hidden fixed inset-0 z-[2100] bg-black bg-opacity-50 hamburger-menu-overlay" onClick={() => setIsMenuOpen(false)}>
          <div className="bg-[#0D1A27] w-80 h-full" onClick={(e) => e.stopPropagation()}>
            {/* Menu Header */}
            <div className="flex items-center justify-between p-4 border-b border-[#273C61]">
              <div className="flex items-center gap-1">
                <img src="/zrm-logo.png" alt="ZRM" className="h-8" />
                <span className="text-base text-white font-medium">v3</span>
              </div>
              <button
                onClick={() => setIsMenuOpen(false)}
                className="p-2 rounded-lg hover:bg-[#273C61] transition-colors text-white"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Menu Content */}
            <div className="p-4 space-y-6">
              {/* Date Navigation */}
              <div>
                <h4 className="text-sm font-bold text-white/60 uppercase tracking-wider mb-3">Date Navigation</h4>
                <button
                  onClick={() => {
                    handleNavigate(new Date());
                    setIsMenuOpen(false);
                  }}
                  className="w-full px-4 py-3 rounded-lg border border-[#273C61] text-white hover:bg-[#273C61] transition-colors font-medium text-left"
                >
                  Today
                </button>
              </div>

              {/* View Selection */}
              <div>
                <h4 className="text-sm font-bold text-white/60 uppercase tracking-wider mb-3">Select view</h4>
                <div className="space-y-2">
                  {[
                    { key: 'month', label: 'Month View' },
                    { key: 'week', label: 'Week View' },
                    { key: 'work_week', label: 'Work Week' },
                    { key: 'three_day', label: '3 Days View' },
                    { key: 'day', label: 'Day View' },
                    { key: 'list', label: 'List View' }
                  ].map((view) => (
                    <button
                      key={view.key}
                      onClick={() => {
                        setCurrentView(view.key);
                        setIsMenuOpen(false);
                      }}
                      className={`w-full px-4 py-3 rounded-lg text-left transition-colors ${
                        currentView === view.key
                          ? 'bg-[#FF7800] border border-[#FF7800] text-white font-bold'
                          : 'border border-[#273C61] text-white hover:bg-[#273C61]'
                      }`}
                    >
                      {view.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Quick Actions */}
              <div>
                <h4 className="text-sm font-bold text-white/60 uppercase tracking-wider mb-3">Add new</h4>
                <div className="space-y-2">
                  <button
                    onClick={() => {
                      onAddNew();
                      setIsMenuOpen(false);
                    }}
                    className="w-full px-4 py-3 bg-[#FF7800] text-white rounded-lg font-medium hover:bg-[#e06800] transition-colors"
                  >
                    New entry                    
                  </button>
                  <button
                    onClick={() => {
                      onCreateSeries();
                      setIsMenuOpen(false);
                    }}
                    className="w-full px-4 py-3 bg-[#FF7800] text-white rounded-lg font-medium hover:bg-[#e06800] transition-colors"
                  >
                    New series
                  </button>
                </div>
              </div>

              {canUseBD && (
                <div>
                  <h4 className="text-sm font-bold text-white/60 uppercase tracking-wider mb-3">Admin</h4>
                  <button
                    onClick={() => {
                      onOpenAdminPanel();
                      setIsMenuOpen(false);
                    }}
                    className="w-full px-4 py-3 rounded-lg border border-[#273C61] text-white hover:bg-[#273C61] transition-colors font-medium text-left"
                  >
                    Brugere &amp; roller
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Desktop Navigation - Fixed at top */}
      <div className="hidden md:flex fixed top-0 left-0 right-0 items-center justify-between gap-4 p-4 border-b border-[#273C61] bg-[#0D1A27] z-[2000]">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1 mr-2">
            <img src="/zrm-logo.png" alt="ZRM" className="h-8" />
            <span className="text-base text-white font-medium">v3</span>
          </div>
          <button
            onClick={() => handleNavigate(new Date())}
            className="px-6 py-2 rounded-lg border border-white/30 text-white hover:bg-[#273C61] transition-colors font-medium"
          >
            Today
          </button>
          <div className="flex items-center gap-2">
            <button
              onClick={() => {
                const unit = currentView === 'day' || currentView === 'three_day' ? 'day' : (currentView === 'month' || currentView === 'list') ? 'month' : 'week';
                const amount = 1;
                const newDate = moment(currentDate).subtract(amount, unit).toDate();
                handleNavigate(newDate);
              }}
              className="p-2 rounded-full hover:bg-[#273C61] transition-colors text-white"
              aria-label="Previous"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={() => {
                const unit = currentView === 'day' || currentView === 'three_day' ? 'day' : (currentView === 'month' || currentView === 'list') ? 'month' : 'week';
                const amount = 1;
                const newDate = moment(currentDate).add(amount, unit).toDate();
                handleNavigate(newDate);
              }}
              className="p-2 rounded-full hover:bg-[#273C61] transition-colors text-white"
              aria-label="Next"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
          <h2 className="text-xl font-semibold flex items-center gap-2 text-white">
            {currentView === 'day'
              ? moment(currentDate).format('dddd, MMMM D, YYYY')
              : currentView === 'three_day'
              ? (() => {
                  const start = moment(currentDate);
                  const end = moment(currentDate).add(2, 'days');
                  return start.month() === end.month()
                    ? `${start.format('MMMM D')}-${end.format('D, YYYY')}`
                    : `${start.format('MMMM D')} - ${end.format('MMMM D, YYYY')}`;
                })()
              : moment(currentDate).format('MMMM YYYY')}
            {(currentView === 'week' || currentView === 'work_week') && (
              <span className="text-sm font-normal px-2 py-0.5 bg-[#273C61] text-white rounded-full">
                Week {moment(currentDate).format('w')}
              </span>
            )}
            {currentView === 'three_day' && (
              <span className="text-sm font-normal px-2 py-0.5 bg-[#FF7800] text-white rounded-full">
                3 Days
              </span>
            )}
          </h2>
        </div>
        
        <div className="flex items-center gap-2 ml-4">
          <button
            className={`px-6 py-2 rounded-lg border font-medium transition-colors ${
              showPeople
                ? 'bg-[#FF7800] text-white border-[#FF7800] hover:bg-[#e06800]'
                : 'bg-transparent text-white border-white/30 hover:bg-[#273C61]'
            }`}
            onClick={() => setShowPeople(!showPeople)}
          >
            Zoho People
          </button>
          <button
            className={`px-6 py-2 rounded-lg border font-medium transition-colors ${
              showProjects
                ? 'bg-[#FF7800] text-white border-[#FF7800] hover:bg-[#e06800]'
                : 'bg-transparent text-white border-white/30 hover:bg-[#273C61]'
            }`}
            onClick={() => setShowProjects(!showProjects)}
          >
            Zoho Projects
          </button>
        </div>


        <div className="flex items-center gap-4">
          <div className="flex rounded-lg border border-[#273C61] overflow-hidden">
            <button
              onClick={() => setCurrentView('month')}
              className={`px-4 py-2 text-sm font-medium ${
                currentView === 'month'
                  ? 'bg-[#FF7800] text-white'
                  : 'text-white/80 hover:bg-[#273C61]'
              }`}
            >
              Month
            </button>
            <button
              onClick={() => setCurrentView('week')}
              className={`px-4 py-2 text-sm font-medium border-l border-[#273C61] ${
                currentView === 'week'
                  ? 'bg-[#FF7800] text-white'
                  : 'text-white/80 hover:bg-[#273C61]'
              }`}
            >
              Week
            </button>
            <button
              onClick={() => setCurrentView('work_week')}
              className={`px-4 py-2 text-sm font-medium border-l border-r border-[#273C61] ${
                currentView === 'work_week'
                  ? 'bg-[#FF7800] text-white'
                  : 'text-white/80 hover:bg-[#273C61]'
              }`}
            >
              Work Week
            </button>
            <button
              onClick={() => setCurrentView('three_day')}
              className={`px-4 py-2 text-sm font-medium border-l border-[#273C61] ${
                currentView === 'three_day'
                  ? 'bg-[#FF7800] text-white'
                  : 'text-white/80 hover:bg-[#273C61]'
              }`}
            >
              3 Days
            </button>
            <button
              onClick={() => setCurrentView('day')}
              className={`px-4 py-2 text-sm font-medium border-l border-[#273C61] ${
                currentView === 'day'
                  ? 'bg-[#FF7800] text-white'
                  : 'text-white/80 hover:bg-[#273C61]'
              }`}
            >
              Day
            </button>
            <button
              onClick={() => setCurrentView('list')}
              className={`px-4 py-2 text-sm font-medium border-l border-[#273C61] ${
                currentView === 'list'
                  ? 'bg-[#FF7800] text-white'
                  : 'text-white/80 hover:bg-[#273C61]'
              }`}
            >
              List View
            </button>
          </div>
          {/* Settings Button */}
          <div className="relative" ref={settingsDropdownRef}>
              <button
                onClick={() => setShowSettingsDropdown(!showSettingsDropdown)}
                className="p-2 rounded-lg hover:bg-[#273C61] transition-colors text-white"
                title="Settings"
                aria-label="Settings"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </button>
              {showSettingsDropdown && (
                <div className="absolute right-0 mt-2 w-52 bg-[#0D1A27] border border-[#273C61] rounded-lg z-50">
                  <div className="px-4 py-2 text-xs font-semibold text-white/40 uppercase tracking-wide border-b border-[#273C61]">
                    New entry default
                  </div>
                  <div className="py-1">
                    <button
                      onClick={() => { setDefaultUseNotes(false); setShowSettingsDropdown(false); }}
                      className={`flex items-center gap-2 w-full text-left px-4 py-2 text-sm ${!defaultUseNotes ? 'text-[#FF7800] font-semibold' : 'text-white/70 hover:bg-[#273C61]'}`}
                    >
                      {!defaultUseNotes && (
                        <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      )}
                      {defaultUseNotes && <span className="w-4 flex-shrink-0" />}
                      Task
                    </button>
                    <button
                      onClick={() => { setDefaultUseNotes(true); setShowSettingsDropdown(false); }}
                      className={`flex items-center gap-2 w-full text-left px-4 py-2 text-sm ${defaultUseNotes ? 'text-[#FF7800] font-semibold' : 'text-white/70 hover:bg-[#273C61]'}`}
                    >
                      {defaultUseNotes && (
                        <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      )}
                      {!defaultUseNotes && <span className="w-4 flex-shrink-0" />}
                      Notes
                    </button>
                  </div>
                  <div className="px-4 py-2 text-xs font-semibold text-white/40 uppercase tracking-wide border-t border-b border-[#273C61]">
                    Gamification
                  </div>
                  <div className="py-1">
                    <button
                      onClick={() => setShowGamification(!showGamification)}
                      className="flex items-center justify-between gap-2 w-full text-left px-4 py-2 text-sm text-white/70 hover:bg-[#273C61]"
                      role="switch"
                      aria-checked={showGamification}
                    >
                      Show armor and quests
                      <span className={`text-xs font-semibold ${showGamification ? 'text-[#FF7800]' : 'text-white/40'}`}>{showGamification ? 'On' : 'Off'}</span>
                    </button>
                  </div>
                  {canUseBD && (
                    <>
                      <div className="px-4 py-2 text-xs font-semibold text-white/40 uppercase tracking-wide border-t border-b border-[#273C61]">
                        Admin
                      </div>
                      <div className="py-1">
                        <button
                          onClick={() => { onOpenAdminPanel(); setShowSettingsDropdown(false); }}
                          className="block w-full text-left px-4 py-2 text-sm text-white/70 hover:bg-[#273C61]"
                        >
                          Brugere &amp; roller
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          {/* Dropdown Button */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className="px-4 py-2 text-sm font-bold bg-[#FF7800] text-white rounded-lg flex items-center gap-2"
            >
              Add 
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            
            {/* Dropdown Menu */}
            {showDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-[#0D1A27] border border-[#273C61] rounded-lg z-50">
                <div className="py-1">
                  <button
                    onClick={() => {
                      onAddNew();
                      setShowDropdown(false);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#273C61]"
                  >
                    New entry
                  </button>
                  <button
                    onClick={() => {
                      onCreateSeries();
                      setShowDropdown(false);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#273C61]"
                  >
                    New series
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
} 